<template>
  <div class="PersonalLeaseOrder">
    <!-- tabs -->
    <el-tabs type="card" v-model="activeName" @tab-click="handleTab">
      <el-tab-pane
        v-for="(item, index) of c_personalTabsList"
        :name="item.name"
        :key="index"
      >
        <span slot="label">
          {{ item.label }}
          <el-popover width="200" trigger="hover" :content="item.tips">
            <i slot="reference" class="el-icon-info icon-info"></i>
          </el-popover>
        </span>
      </el-tab-pane>
    </el-tabs>

    <!-- 即将到期引导气泡 -->
    <div
      v-show="expireSoonTooltipVisible"
      class="pin-tooltip-bubble"
      :style="{ top: expireSoonTooltipTop + 'px', left: expireSoonTooltipLeft + 'px' }"
    >
      <span class="pin-tooltip-body">
        <span class="pin-tooltip-text">新增功能, 快速查看临期订单</span>
        <i class="el-icon-close pin-tooltip-close" @click.stop="dismissExpireSoonTooltip(true)" />
      </span>
      <div class="pin-tooltip-arrow" />
    </div>

    <!-- 筛选&table -->
    <base-list-management
      ref="baseListManagement"
      :configData.sync="m_configData"
    >
      <PublicExport
        slot="custom-export"
        v-if="judgePermission('under_lease_order_rent_export')"
        exportTitle="租赁中订单导出"
        exportTemplate="Personal"
        :getSearchData="searchParams"
        templateCode="vehicle-leasing-rent-order"
        :getSearchCondition="getSearchCondition"
      />
    </base-list-management>

    <!-- 签约支付宝支付 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <signAlipayWithholdDrawer ref="signAlipayWithholdDrawerRef" @update="update" />

    <!-- 发起支付宝支付 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <alipayWithholdDialogNew ref="alipayWithholdDialogNewRef" />

    <!-- 解约支付宝、网约代扣 -->
    <UnBindWithhold ref="unBindWithholdRef" @update="update"/>

    <!-- 签约网约钱包支付抽屉 -->
    <SignWithholdDrawer ref="signWithholdDrawerRef" @complete="update" />

    <!-- 一键换车 -->
    <OneKeyCarChange ref="oneKeyChangeCarRef" @updateList="update" />

    <dialogWrap
      :title="'提示'"
      v-model="dialogConfirmData.visible"
      :width="'30%'"
    >
      <span>{{ dialogConfirmData.content }}</span>
      <template slot="footer">
        <el-button @click="dialogConfirmData.visible = false">取消</el-button>
        <el-button @click="dialogConfirm" type="primary">确认</el-button>
      </template>
    </dialogWrap>
  </div>
</template>
<script>
import alipayWithholdDialogNew from '@/pages/orders/components/alipayWithholdDialogNew.vue'
import signAlipayWithholdDrawer from '@/pages/orders/components/paymentChannels/aliPay/index.vue'
// eslint-disable-next-line import/no-cycle
import { getAllEmployeeList, querySalesManager } from '@/api/carManage/index.js'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { checkBeforeChangeCar } from '@/api/domain/finance.js'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import UnBindWithhold from '@/pages/orders/components/UnBindWithhold.vue'
import { UNBIND_TITLE, WITHHOLD_TYPE } from '@/pages/orders/components/const'
import SignWithholdDrawer from '@/pages/orders/components/paymentChannels/driverIncomes/index.vue'
import { check } from '@/pages/orders/components/withholdCheck.js'
import OneKeyCarChange from '@/pages/orders/personalOrder/components/oneKeyCarChange'
import { generateExportCondition } from '@/utils/exportUtils.js'
import { parseQueryJsonStr } from '@/utils/querySchema'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { getLocalStorage, setLocalStorage } from '@/utils/cache'
import { hashStr } from '@/utils/hash'
// TODO: config里出现和组件循环依赖，需要修正
// eslint-disable-next-line import/no-cycle
import config from '../config'
import personalConfig from '../config/personalConfig'


export default {
  components: {
    signAlipayWithholdDrawer,
    alipayWithholdDialogNew,
    UnBindWithhold,
    SignWithholdDrawer,
    OneKeyCarChange,
  },
  props: {
    childActiveName: {
      type: String,
      default: undefined,
    },
  },
  data() {
    const { query: queryStr } = this.$route?.query
    const queryObj = queryStr ? parseQueryJsonStr(queryStr) : {}
    const {
      // 个人租赁订单tabs
      c_personalTabsList,
    } = config.call(this)
    const m_configData = personalConfig.call(this)
    return {
      dialogConfirmData: { visible: false, content: '', rowData: {} },
      // personalConfig内通过this引用
      // eslint-disable-next-line vue/no-unused-properties
      idCardCache: {},
      c_personalTabsList,
      m_configData,
      activeName: this.childActiveName || '2',
      queries: queryObj,
      // c_personalTabsList有引用
      // eslint-disable-next-line vue/no-unused-properties
      carConditionList: [],
      // c_personalTabsList有引用
      // eslint-disable-next-line vue/no-unused-properties
      customerConditionList: [],
      // c_personalTabsList有引用
      // eslint-disable-next-line vue/no-unused-properties
      dmConditionList: [], // 所属车管
      dmLoading: false, // 所属车管loading
      // eslint-disable-next-line vue/no-unused-properties
      salesManagerConditionList: [],
      expireSoonTooltipVisible: false,
      expireSoonTooltipTop: 0,
      expireSoonTooltipLeft: 0,
    }
  },
  computed: {
    ...mapState({
      // 租赁模式
      categoryList: (state) => {
        const list = [...state.global.categoryList]
        list.unshift({
          code: '',
          name: '全部',
        })
        return list
      },
    }),
    ...mapGetters(['allCities']),
    isExpireSoonTab() {
      // 即将到期tab
      return this.activeName === '24'
    },
  },
  activated() {
    const { query: queryStr } = this.$route?.query
    const queryObj = queryStr ? parseQueryJsonStr(queryStr) : {}
    if (queryObj.from === 'personalSignContract') {
      this.goSearch()
    }
  },
  watch: {
    categoryList: {
      handler(val) {
        // 设置租赁模式
        this.$nextTick(() => {
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'list',
            key: 'rentCategory',
            data: val,
          })
        })
      },
      deep: true,
    },
    allCities: {
      handler(val) {
        this.m_configData.formData.list.find((item) => item.itemConfig.prop === 'adcode').elConfig.options.list = val
      },
      immediate: true,
    },
  },
  mounted() {
    this.init()
    this.loadAllDriverManagers()
    this.loadSalesManagerList()
    this.updateFilterForTab()
    this.$nextTick(() => this.checkExpireSoonTooltip())
  },
  methods: {
    update() {
      this.goSearch()
    },
    getRouteQuery() {
      const { search = {} } = this.queries
      const { theOrderStart = '', deptId = '', id = '' } = search

      if (theOrderStart !== '') {
        this.m_configData.formData.formProps.model.TheOrderStart = theOrderStart
      }
      if (deptId !== '') {
        this.m_configData.formData.formProps.model.deptIdList = [deptId]
      }
      if (id !== '') {
        this.m_configData.formData.formProps.model.id = String(id)
      }
    },
    dialogConfirm() {
      this.dialogConfirmData.visible = false
      const { rowData } = this.dialogConfirmData
      this.toOrderRentTurnRentMode(rowData, 5)
    },
    // 转租赁模式弹框提示 有引用
    // eslint-disable-next-line vue/no-unused-properties
    toOrderRentTurnRentModeConfirm(row) {
      const { renewalOfContract, startDate } = row
      const FORMAT_TYPE = 'YYYYMMDD'
      const left = parseInt(moment(startDate).format(FORMAT_TYPE))
      const right = parseInt(moment(Date.now()).format(FORMAT_TYPE))
      if (right < left) {
        this.$message.warning('该订单还未正式执行，不可操作此业务')
        return
      }
      // renewalOfContract === 1原订单且续约过 未到计租截止日
      if (renewalOfContract === 1) {
        this.dialogConfirmData = {
          rowData: row,
          visible: true,
          content:
            '该订单已续约，变更业务模式续约订单将自动作废，可在变更业务后的订单重新续约。是否确认继续？',
        }
        return
      }
      // 租赁模式
      this.toOrderRentTurnRentMode(row, 5)
    },
    goSearch() {
      this.$refs.baseListManagement?.searchForm()
    },
    // 展示开启网约钱包支付
    // eslint-disable-next-line vue/no-unused-properties
    async showOpenWalletWithhold(row) {
      const { id: orderId, rentCategory } = row
      check(orderId, WITHHOLD_TYPE.WALLET).then(() => {
        this.$refs.signWithholdDrawerRef.openDrawer({ orderId, rentCategory })
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    showOpenAlipayWithhold(row) {
      check(row.id, WITHHOLD_TYPE.ALIPAY).then(() => {
        this.$refs.signAlipayWithholdDrawerRef.openDrawer(row)
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    showRescindAlipayWithhold(row, type) {
      this.$refs.unBindWithholdRef.open({
        title: UNBIND_TITLE[type],
        orderId: row.id,
        type, // 1:网约钱包支付 2:支付宝支付
      })
    },
    // 临时换车
    // eslint-disable-next-line vue/no-unused-properties
    toOrderTransferCar(row, type) {
      const contractId = row.id
      const { carId } = row
      this.$router.push({
        path: '/underLease/underLeaseOrder/transferCar',
        query: {
          relationOrderType: type,
          contractId,
          carId,
          customerId: row.customerId,
          customerName: row.customerName,
        },
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    async showOneKeyChangeCar(row, type) {
      if (type === 'selectNewCar') {
        const { code } = await checkBeforeChangeCar({
          orderId: row.id,
        })
        if (code === 1) {
          this.$refs.oneKeyChangeCarRef.open(row, type)
        }
      } else {
        this.$refs.oneKeyChangeCarRef.open(row, type)
      }
    },
    // 转租赁
    toOrderRentTurnRentMode(row, type) {
      const contractId = row.id
      const { carId } = row
      this.$router.push({
        path: '/underLease/underLeaseOrder/rentTurnRentMode',
        query: {
          relationOrderType: type,
          contractId,
          carId,
          customerId: row.customerId,
          customerName: row.customerName,
        },
      })
    },
    // 去客户还车页面
    // eslint-disable-next-line vue/no-unused-properties
    toReturnCarPage(row) {
      const queryObj = { orderId: row.id }
      const queryStr = JSON.stringify(queryObj)
      this.$router.push({
        name: 'return_lease_start',
        query: {
          query: queryStr,
        },
      })
    },
    // 去租赁订单详情页面
    // eslint-disable-next-line vue/no-unused-properties
    toOrderDetailPage(query, hash) {
      this.$router.push({
        path: '/workbench/rentOrder/detail',
        query: {
          ...query,
          orderType: 'personal',
        },
        hash,
      })
    },
    // 车牌号模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    carRemoteMethod(query) {
      if (query.length >= 4) {
        FuzzySearch({
          state: 1,
          plateNo: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'list',
            key: 'carId',
            data,
          })
        })
      }
    },
    // 客户模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    customerRemoteMethod(query) {
      if (query.length >= 1) {
        searchByCustomerNameSensitive({
          customerState: 1,
          customerType: 1,
          customerName: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'list',
            key: 'customerId',
            data,
          })
        })
      }
    },
    // 加载所有司管
    loadAllDriverManagers() {
      this.dmLoading = true
      getAllEmployeeList({ includeDisabled: 'YES' })
        .then((res) => {
          if (res.code === 1) {
            this.$refs.baseListManagement?.setItemData({
              elConfigKey: 'list',
              key: 'driverManagerId',
              data: res.data,
            })
            this.dmConditionList = res.data
          }
        })
        .finally(() => {
          this.dmLoading = false
        })
    },
    // 加载销售经理
    loadSalesManagerList() {
      querySalesManager()
        .then((res) => {
          if (res.code === 1) {
            this.$refs.baseListManagement?.setItemData({
              elConfigKey: 'list',
              key: 'salesManagerId',
              data: res.data,
            })
            this.salesManagerConditionList = res.data
          }
        })
    },
    // tabs切换
    handleTab() {
      if (this.isExpireSoonTab) {
        this.markExpireSoonTabVisited()
      }
      this.updateFilterForTab()
      this.$refs.baseListManagement?.reset()
    },
    updateFilterForTab() {
      const { list } = this.m_configData.formData
      const isExpireSoon = this.isExpireSoonTab
      const rentFinish = list.find((item) => item.itemConfig?.prop === 'rentFinIsh')
      const orderStart = list.find((item) => item.itemConfig?.prop === 'TheOrderStart')
      const rentEndTimeRange = list.find((item) => item.itemConfig?.prop === 'rentEndTimeRange')
      if (rentFinish) this.$set(rentFinish, 'isShow', !isExpireSoon)
      if (orderStart) this.$set(orderStart, 'isShow', !isExpireSoon)
      if (rentEndTimeRange) this.$set(rentEndTimeRange, 'isShow', isExpireSoon)
    },
    getUserId() {
      return this.$store?.getters?.userInfo?.id
    },
    expireSoonTooltipVisitedKey() {
      return `expireSoonTabVisited_${hashStr(String(this.getUserId() || ''))}`
    },
    expireSoonTooltipDismissedKey() {
      return `expireSoonTabTooltipDismissed_${hashStr(String(this.getUserId() || ''))}`
    },
    checkExpireSoonTooltip() {
      if (this._expireSoonTooltipChecked) return

      const uid = this.getUserId()
      if (!uid) {
        // userInfo 尚未加载，500ms 后重试
        setTimeout(() => this.checkExpireSoonTooltip(), 500)
        return
      }

      this._expireSoonTooltipChecked = true

      const visited = getLocalStorage(this.expireSoonTooltipVisitedKey(), false)
      if (visited) return

      const dismissed = getLocalStorage(this.expireSoonTooltipDismissedKey(), false)
      if (dismissed) return

      this.expireSoonTooltipVisible = true
      this.$nextTick(() => this.updateExpireSoonTooltipPosition())
    },
    updateExpireSoonTooltipPosition() {
      const tabEl = this.$el.querySelector('[id^="tab-24"]')
      if (!tabEl) return
      const tabRect = tabEl.getBoundingClientRect()
      const parentRect = this.$el.getBoundingClientRect()
      this.expireSoonTooltipTop = tabRect.top - parentRect.top - 8
      this.expireSoonTooltipLeft = tabRect.left - parentRect.left + tabRect.width / 2
    },
    dismissExpireSoonTooltip(save = true) {
      this.expireSoonTooltipVisible = false
      if (save) {
        setLocalStorage(this.expireSoonTooltipDismissedKey(), true)
      }
    },
    markExpireSoonTabVisited() {
      setLocalStorage(this.expireSoonTooltipVisitedKey(), true)
      this.expireSoonTooltipVisible = false
    },
    init() {
      this.getRouteQuery()
      // 获取租赁模式
      this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' })
    },
    // 筛选参数处理
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      // 时间处理
      // 订单创建时间
      val.createTimeStart = (val.TheOrderStart && val.TheOrderStart[0]) || ''
      val.createTimeEnd = (val.TheOrderStart && val.TheOrderStart[1]) || ''
      // 订单确认时间
      val.confirmTimeStart =
        (val.TheOrderconfirmtime && val.TheOrderconfirmtime[0]) || ''
      val.confirmTimeEnd =
        (val.TheOrderconfirmtime && val.TheOrderconfirmtime[1]) || ''
      // 发车验车时间
      val.outStockTimeStart = (val.TheCarExTime && val.TheCarExTime[0]) || ''
      val.outStockTimeEnd = (val.TheCarExTime && val.TheCarExTime[1]) || ''
      // 计租结束日
      if (this.isExpireSoonTab) {
        val.tabNo = 21 // 租赁中状态码（tabNo），即将到期为租赁中的子集
        val.noRenewal = 1 // 过滤出未续约的订单
        if (val.rentEndTimeRange) {
          const days = Number(val.rentEndTimeRange)
          const now = moment()
          val.rentEndTimeStart = now.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          val.rentEndTimeEnd = now.clone().add(days, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
      } else {
        val.rentEndTimeStart = (val.rentFinIsh && val.rentFinIsh[0]) || ''
        val.rentEndTimeEnd = (val.rentFinIsh && val.rentFinIsh[1]) || ''
        val.tabNo = Number(this.activeName)
      }
      // 免租结束日
      val.presentEntTimeStart =
        (val.freeCycleEndTime && val.freeCycleEndTime[0]) || ''
      val.presentEntTimeEnd =
        (val.freeCycleEndTime && val.freeCycleEndTime[1]) || ''
      // 个人租赁订单固定参数
      val.bizType = 10 // 10个人订单 20企业子订单
      return val
    },
    // 异步导出参数展示
    getSearchCondition() {
      const params = this.searchParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const conditions = this.m_configData.formData.list
        .filter((item) => item.isShow !== false)
        .map((item) => {
          const {
            el,
            itemConfig: { label, prop: key },
          } = item
          const val = params[key]
          if (key === 'carId') {
            item.elConfig.options.list = this.carConditionList
          }
          if (key === 'customerId') {
            item.elConfig.options.list = this.customerConditionList
          }
          if (key === 'driverManagerId') {
            item.elConfig.options.list = this.dmConditionList
          }
          if (key === 'salesManagerId') {
            item.elConfig.options.list = this.salesManagerConditionList
          }
          const { matchValue, hidden } = generateExportCondition[el](val, item)
          return {
            label,
            key,
            matchValue,
            hidden,
          }
        })
      conditions.push({
        label: '订单类型',
        matchValue: '个人租赁订单',
      })
      conditions.push({
        label: '订单状态',
        matchValue: this.c_personalTabsList.find((item) => item.name === this.activeName)?.label,
      })
      return conditions
    },
    // 异步导出参数
    searchParams() {
      return this.$refs.baseListManagement?.getParams()
    },
  },
}
</script>
<style lang="less" scoped>
.PersonalLeaseOrder {
  position: relative;
}
.pin-tooltip-bubble {
  position: absolute;
  transform: translate(-50%, -100%);
  z-index: 9998;
  .pin-tooltip-body {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    background: #ecf5ff;
    color: #e63946;
    border: 1px solid #b3d8ff;
    border-radius: 8px;
    font-size: 12px;
    white-space: nowrap;
    box-shadow: 0 4px 16px rgba(39, 107, 236, 0.1);
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -40%;
      width: 30%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.7), transparent);
      transform: skewX(-30deg);
      animation: expireSoonShimmer 10s ease-in-out infinite;
    }
  }
  .pin-tooltip-text {
    line-height: 1;
  }
  .pin-tooltip-close {
    font-size: 12px;
    cursor: pointer;
    color: #8cb6f0;
    line-height: 1;
    &:hover {
      color: #276bec;
    }
  }
  .pin-tooltip-arrow {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #b3d8ff;
    &::after {
      content: '';
      position: absolute;
      top: -7px;
      left: -5px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #ecf5ff;
    }
  }
}
@keyframes expireSoonShimmer {
  0% {
    left: -40%;
  }
  70% {
    left: -40%;
  }
  100% {
    left: 100%;
  }
}
</style>
